import React from 'react'
import {Switch,Route} from 'react-router-dom'
import asyncComponent from "../../../util/asyncComponent";
const ClosingAndOtherBank =({match})=>(
    <Switch>
          <Route  path={`${match.url}/BankConciliation`} component={asyncComponent(()=>import( './BankConciliation/index'))} />
          <Route  path={`${match.url}/ReverseBankConciliation`} component={asyncComponent(()=>import( './ReverseBankConciliation/index'))} />

    </Switch>
)
export default ClosingAndOtherBank;